module.exports = __webpack_public_path__ + "static/media/Snowflake.afb0eacd.svg";